var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigherReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_317_1318)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1922 47.3946V64.2268C24.19 64.4308 24.1077 64.6257 23.963 64.7696C23.8184 64.9134 23.623 64.9947 23.419 64.9958H16.7732C16.5688 64.9958 16.3728 64.9149 16.2279 64.7708C16.0831 64.6267 16.0011 64.4312 16 64.2268V47.3946H24.1922ZM16 41.8979L33.5716 26.5233C37.4628 30.3258 41.2357 34.9437 45.0846 38.7461L59.1241 24.6475L54.6034 20.1183L67.9163 20V33.4269L63.5772 29.0879C60.4634 32.2439 53.0993 39.194 49.9855 42.312C46.0437 46.2496 44.1636 46.3215 40.2259 42.3838L33.5716 34.9817L25.7723 41.8979H16ZM64.3208 36.3464V64.2311C64.3186 64.4343 64.2369 64.6286 64.0932 64.7724C63.9494 64.9161 63.7551 64.9978 63.5519 65H56.9018C56.6986 64.9967 56.5047 64.9139 56.3617 64.7694C56.2188 64.6249 56.1382 64.4301 56.1371 64.2268V44.2048C57.4046 42.9753 58.8833 41.5473 60.3916 40.0939L63.5392 37.0646C63.7898 36.8116 64.0536 36.5718 64.3293 36.3464H64.3208ZM50.9446 48.8733V64.2268C50.9424 64.4308 50.8601 64.6257 50.7155 64.7696C50.5708 64.9134 50.3754 64.9947 50.1714 64.9958H43.5256C43.3216 64.9947 43.1262 64.9134 42.9816 64.7696C42.8369 64.6257 42.7546 64.4308 42.7524 64.2268V50.5126C43.5446 50.7049 44.3583 50.7943 45.1733 50.7788C47.2467 50.7487 49.2609 50.0837 50.9446 48.8733ZM37.5684 47.6059V64.2057C37.5662 64.4097 37.4839 64.6046 37.3392 64.7485C37.1946 64.8923 36.9992 64.9736 36.7952 64.9746H30.1452C29.9416 64.9735 29.7466 64.8922 29.6027 64.7482C29.4587 64.6042 29.3773 64.4093 29.3762 64.2057V46.1947C29.5114 46.0933 29.6424 45.9877 29.7691 45.8779L33.0899 42.9204L35.7686 45.8779L35.9756 46.0933C36.5164 46.6369 37.0473 47.1327 37.5684 47.5805V47.6059Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1318",
    x1: 128.912,
    y1: 76.2137,
    x2: 64.2309,
    y2: -57.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B947F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigherReturnIcon);
export default __webpack_public_path__ + "static/media/higherReturnIcon.3be65069f342e819d3f3e973b6aeddb0.svg";
export { ForwardRef as ReactComponent };